import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCode7({ name }) {
  return <ReferanceAsyncSelect name={name} labelCategory="EK KARTI" />
}
